import React, { useContext } from 'react';

import PropTypes from 'prop-types';

import { Typography, Button, Link } from '@mui/material';

import ENSSpecification from '../../../assets/ENS Consignment Spec V1.0 2.xlsx';

import { useStepper } from '../../../components/Stepper';
import { postENSXMLFile } from '../../../api/GBENSDec';
import { GBENSContext } from '../GBENSContainer';

const ConsignmentUpload = ({ handleGetXMLDetails, companyId }) => {
  const { isReadOnly } = useContext(GBENSContext);
  const { gotoStep } = useStepper();

  const handleUpload = async (e) => {
    const files = e.target.files;
    for (const f of files) {
      if (f.name.slice(-3).toLowerCase() === 'xml') {
        try {
          const fileText = await f.text();
          const data = await postENSXMLFile(fileText, companyId);
          handleGetXMLDetails(data);
          gotoStep('AddingConsignment');
        } catch (e) {
          console.error('error processing file', e);
        }
      }
    }
  };

  return (
    <>
      <div style={{ backgroundColor: '#F6F6F6', padding: 30 }}>
        <Typography id="modal-modal-title" variant="h6" component="h6" style={{ marginBottom: 20 }}>
          Upload Consignment File
        </Typography>
        <Typography id="modal-modal-title" variant="p" component="p" style={{ marginBottom: 20 }}>
          The CABIE ENS Portal supports uploading Consignment data using our XML specification.
        </Typography>
        <Typography id="modal-modal-title" variant="p" component="p" style={{ marginLeft: 30, marginBottom: 20 }}>
          <Link href={ENSSpecification} target="_blank" download="ENS Consignment Spec V1.0.xlsx">
            Download ENS specification
          </Link>
        </Typography>
        <Typography id="modal-modal-title" variant="p" component="p" style={{ marginBottom: 20 }}>
          Once uploaded the system will validate the data in line with ENS requirements.
        </Typography>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', padding: 30 }}>
        <div></div>
        <Button variant="outlined" component="label" disabled={isReadOnly}>
          Upload file <input onChange={handleUpload} multiple={false} type="file" hidden disabled={isReadOnly} />
        </Button>
      </div>
    </>
  );
};

ConsignmentUpload.propTypes = {
  handleGetXMLDetails: PropTypes.func.isRequired,
  companyId: PropTypes.string.isRequired,
};

export default ConsignmentUpload;
